import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import {
  ChartLine,
  Store,
  Menu,
  FileText,
  PackageX,
  TicketPercent,
} from 'lucide-react';

export const HeaderMenu = ({
  currentPage,
  reportData,
  onPrint,
  on80mmPrint,
}) => {
  const isComprehensive = currentPage === 'comprehensive';
  const isPOS = currentPage === 'pos';
  const isDelivery = currentPage === 'delivery';
  const isTopSellers = currentPage === 'top-sellers';
  const isSalesByCategory = currentPage === 'sales-by-category';
  const isInventoryDamage = currentPage === 'inventory-damage';
  const isPromotions = currentPage === 'promotions';

  const getPageTitle = () => {
    if (isComprehensive) return 'POS Performance Reports';
    if (isPOS) return 'POS Terminal Reports';
    if (isDelivery) return 'Delivery Report';
    if (isTopSellers) return 'Top Seller Items';
    if (isSalesByCategory) return 'Sales by Category';
    if (isInventoryDamage) return 'Inventory Damage';
    if (isPromotions) return 'Promotion Report';
    return 'POS Reports';
  };

  const getPageIcon = () => {
    if (isComprehensive) {
      return <ChartLine className="text-primary text-2xl w-8 h-8" />;
    }
    if (isInventoryDamage) {
      return <PackageX className="text-primary text-2xl w-8 h-8" />;
    }
    if (isPromotions) {
      return <TicketPercent className="text-primary text-2xl w-8 h-8" />;
    }
    return <Store className="text-primary text-2xl w-8 h-8" />;
  };

  return (
    <header className="bg-card border-b border-border no-print">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo and Title */}
          <div className="flex items-center space-x-3">
            {getPageIcon()}
            <h1 className="text-2xl font-bold text-foreground">
              {getPageTitle()}
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4">
            {/* {isComprehensive && (
              <Link to="/pos-reports">
                <Button
                  variant="outline"
                  className="inline-flex items-center"
                  data-testid="link-pos-reports"
                >
                  <Store className="mr-2 h-4 w-4" />
                  POS Terminal Reports
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            )}

            {isPOS && (
              <Link to="/report-generator">
                <Button
                  variant="outline"
                  className="inline-flex items-center"
                  data-testid="link-comprehensive-reports"
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  <ChartLine className="mr-2 h-4 w-4" />
                  Comprehensive Reports
                </Button>
              </Link>
            )} */}

            {reportData && onPrint && (
              <>
                {/* <Button
                  onClick={onPrint}
                  variant="outline"
                  className="inline-flex items-center"
                  data-testid={isPOS ? 'button-print-pos' : 'button-print'}
                >
                  <Printer className="mr-2 h-4 w-4" />
                  {isPOS ? 'Print POS Reports' : 'Print Report'}
                </Button> */}
                {on80mmPrint && (
                  <Button
                    onClick={on80mmPrint}
                    variant="outline"
                    className="inline-flex items-center"
                    data-testid="button-80mm-print"
                  >
                    <FileText className="mr-2 h-4 w-4" />
                    Print Summary
                  </Button>
                )}
              </>
            )}
          </div>

          {/* Mobile Menu */}
          <div className="md:hidden">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="outline"
                  size="icon"
                  className="h-10 w-10"
                  style={{
                    backgroundColor: 'transparent',
                    border: 'none !important',
                  }}
                  data-testid="mobile-menu-trigger"
                >
                  <Menu className="h-5 w-5" />
                  <span className="sr-only">Open menu</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                {/* {isComprehensive && (
                  <DropdownMenuItem asChild>
                    <Link to="/pos-reports" className="w-full">
                      <Store className="mr-2 h-4 w-4" />
                      POS Terminal Reports
                      <ArrowRight className="ml-auto h-4 w-4" />
                    </Link>
                  </DropdownMenuItem>
                )}

                {isPOS && (
                  <DropdownMenuItem asChild>
                    <Link to="/report-generator" className="w-full">
                      <ArrowLeft className="mr-2 h-4 w-4" />
                      Comprehensive Reports
                      <ChartLine className="ml-auto h-4 w-4" />
                    </Link>
                  </DropdownMenuItem>
                )} */}

                {reportData && onPrint && (
                  <>
                    {/* <DropdownMenuSeparator /> */}
                    {/* <DropdownMenuItem onClick={onPrint}>
                      <Printer className="mr-2 h-4 w-4" />
                      {isPOS ? 'Print POS Reports' : 'Print Report'}
                    </DropdownMenuItem> */}
                    {on80mmPrint && (
                      <DropdownMenuItem onClick={on80mmPrint}>
                        <FileText className="mr-2 h-4 w-4" />
                        Print Summary
                      </DropdownMenuItem>
                    )}
                  </>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </div>
    </header>
  );
};
